import { CurrentUser } from 'libs/hooks/useCurrentUser';
import { TagKey, TagValue } from '@xbcb/shared-types';

export const isHtsManagementTeamUser = (currentUser: CurrentUser): boolean => {
  const { businessSupportTeams } = currentUser;
  const teams = businessSupportTeams?.nodes ?? [];
  return Boolean(
    teams.find(({ tags }) =>
      tags?.some(
        ({ key, value }: { key: string; value: string }) =>
          key === TagKey.STRATEGIC_BUSINESS_UNIT &&
          value === TagValue.CBMS_HTS_MANAGEMENT_TEAM,
      ),
    ),
  );
};
